import i18n from 'i18next';
import { get } from 'lodash';
import { Link } from 'react-router-dom';

import { None, sortBy } from './helpers';

export const name = {
  key: 'site',
  title: i18n.t('table.site', 'Site'),
  sorter: sortBy('name'),
  get: record => get(record, 'name'),
  render: record => {
    const { name, id } = record || {};
    return [name, id].every(Boolean) ? <Link to={`/sites/${id}`}>{name}</Link> : <None />;
  },
  filterProperty: 'name',
};

export const city = {
  title: i18n.t('table.city', 'City'),
  dataIndex: 'city',
  filterProperty: 'city',
  sorter: sortBy('city'),
  get: record => get(record, 'city'),
};

export const state = {
  title: i18n.t('table.state', 'State'),
  dataIndex: 'state',
  filterProperty: 'state',
  sorter: sortBy('state'),
  get: record => get(record, 'state'),
};

export const address = {
  title: i18n.t('table.location', 'Location'),
  key: 'location',
  filterProperty: 'address',
  sorter: sortBy('address'),
  get: record => get(record, 'address'),
  render(record) {
    const { address } = record || {};
    return address || <None />;
  },
};

export const numTurbines = {
  key: 'numTurbines',
  title: i18n.t('table.numTurbines', '# Turbines'),
  dataIndex: 'turbines',
  render: turbines => (turbines ? turbines.length : <None />),
  sorter: sortBy('turbines.length'),
  get: record => get(record, ['turbines', 'length']),
};
